// src/components/MarketPanel.jsx (s127, Phase 4c-1) — the housing and trade around a city, from the Census
// (src/data/localMarket.js, generated by scripts/build-local-market.mjs). Six stacked cards, the same shape as
// AirPanel (a seventh, metro cleaner pay from BLS OEWS, s139, src/data/metroWage.js): every line is short, so data labels are not read as template sentences by measure-template-share. What
// the figures mean for the work lives once, on /methodology#market.
import React from 'react';
import { Link } from 'react-router-dom';

const usd = (m) => (m ? `$${m.v.toLocaleString('en-US')}${m.plus ? '+' : ''}` : null);
const pct = (v) => `${Number.isInteger(v) ? v : v.toFixed(1)}%`;

export default function MarketPanel({ market, wage, T, fontBody, fontMono }) {
  if (!market) return null;
  const c = market.county;
  const card = (key, label, value, note) => (
    <div key={key} data-market={key} style={{ minWidth: 150 }}>
      <div style={{ fontFamily: fontMono, fontSize: 10, letterSpacing: '0.12em', color: T.inkSoft }}>{label}</div>
      <div style={{ fontFamily: fontMono, fontSize: 22, color: T.ink, margin: '2px 0' }}>{value}</div>
      <div style={{ fontFamily: fontBody, fontSize: 13, color: T.inkSoft }}>{note}</div>
    </div>
  );
  const noMedian = 'not added across places';
  return (
    <div data-region="market-panel" style={{ margin: '8px 0 28px' }}>
      <div style={{ fontFamily: fontMono, fontSize: 11, letterSpacing: '0.18em', color: T.sienna, marginBottom: 12 }}>THE LOCAL MARKET</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '14px 36px' }}>
        {card('income', 'HOUSEHOLD INCOME', usd(market.income) || 'No median', market.income ? 'median household' : noMedian)}
        {card('homeValue', 'HOME VALUE', usd(market.homeValue) || 'No median', market.homeValue ? 'median, owner-occupied' : noMedian)}
        {card('ownerPct', 'OWNER-OCCUPIED', pct(market.ownerPct), 'of occupied homes')}
        {card('detachedPct', 'DETACHED HOUSES', pct(market.detachedPct), `of ${market.units.toLocaleString('en-US')} homes`)}
        {card('bigBldgPct', 'IN 20+ UNIT BUILDINGS', pct(market.bigBldgPct), 'of all homes')}
        {card('firms', 'CLEANING FIRMS (COUNTY)', c.firms.toLocaleString('en-US'), `${c.name} · ${c.per10k}/10k people`)}
        {wage && (wage.janitor
          ? card('wage', `MEDIAN CLEANER PAY · MAY ${wage.year}`, `$${wage.janitor.toFixed(2)}/hr`, `${wage.area} metro`)
          : card('wage', 'CLEANER PAY (METRO)', 'No metro figure', wage.none === 'nonmetro' ? 'outside any metro area' : 'not published for this metro'))}
      </div>
      <p style={{ fontFamily: fontMono, fontSize: 11, margin: '10px 0 0' }}>
        <Link to="/methodology#market" style={{ color: T.inkSoft }}>How we read the market</Link>
      </p>
    </div>
  );
}
